export const platforms = {
  facebook: {
    name: 'Messenger',
    link: '/facebook',
    logo: 'https://pipe.bot/img/facebook.svg'
  },
  telegram: {
    name: 'Telegram',
    link: '/telegram',
    logo: 'https://pipe.bot/img/telegram.svg'
  },
  slack: {
    name: 'Slack',
    link: '/slack',
    logo: 'https://pipe.bot/img/d/m/39/c98ff8.svg'
  },
  viber: {
    name: 'Viber',
    link: '/viber',
    logo: 'https://pipe.bot/img/viber.svg'
  },
  webhook: {
    name: 'Webhook',
    link: '/bot/create',
    logo: 'https://pipe.bot/img/logo.svg'
  },
  lowcode: {
    name: 'Low-code',
    link: '/bot/create/low-code',
    logo: 'https://pipe.bot/img/logo.svg'
  }
}
